import React from "react";

import { chakra } from "@chakra-ui/react";

import { ClassesEnum } from "@ts/enums/ClassesEnum";

import { getTrackingId } from "@utils/utils";

import { Text } from "@components/Text";

interface PropTypes {
    children: React.ReactNode;
    isActive: boolean;
    className?: string;
    classHierarchy?: ClassesEnum[];
    action?: string;
    onClick: () => void;
}

const SelectablePill = ({
    children,
    isActive,
    className,
    action,
    classHierarchy,
    onClick
}: PropTypes) => (
    <chakra.div
        className={className ?? ClassesEnum.Button}
        data-tracking-id={getTrackingId(
            classHierarchy ?? [ClassesEnum.Button],
            action ?? "selectPill"
        )}
        onClick={onClick}
        borderRadius={25}
        transition="all 0.2s"
        border="2px solid transparent"
        px={4}
        py={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
        cursor="pointer"
        bg="gray.100"
        userSelect="none"
        background={`linear-gradient(${
            isActive ? "white" : "var(--euka-colors-gray-100)"
        } 0 0) padding-box, ${
            isActive ? "#F0A32F" : "var(--euka-colors-gray-300)"
        } border-box`}
    >
        <Text fontSize={14} type="subHeading">
            {children}
        </Text>
    </chakra.div>
);

export default SelectablePill;
